import React from "react";
import PropTypes from "prop-types";
import TableActionBtnGroup from "../../../components/table/all-tables/tableactionbtngroup/TableActionBtnGroup";
import { EditReffPartner, noDataPresent } from "../../../locales/en";

const ReferralSalesLeadTable = ({
  columns,
  getTableProps,
  getTableBodyProps,
  headerGroups,
  prepareRow,
  rows,
  getSalesLeadName,
  toggleSalesEdit,
  handleDeleteSelected,
  EDIT_REFERRAL_TOOLTIP_CONFIG
}) => {
  return (
    <table
      className="mt-2 salselead-table-details reffSaleslead"
      {...getTableProps()}
    >
      <thead>
        {headerGroups.map((headerGroup, headerGroupIdx) => (
          <tr
            className="parentrow"
            {...headerGroup.getHeaderGroupProps()}
            key={headerGroup?.id || headerGroupIdx}
          >
            {headerGroup.headers.map((column, colIdx) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                key={column.id || colIdx}
              >
                <span>{column.render("Header")}</span>
              </th>
            ))}
            <th className="text-end" key="action-header">
              {EditReffPartner?.action}
            </th>
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="text-center">
              {noDataPresent}
            </td>
          </tr>
        ) : (
          rows.map((row, rowIdx) => {
            prepareRow(row);
            return (
              <React.Fragment key={row.id || rowIdx}>
                <tr
                  className="parentrow"
                  {...row.getRowProps()}
                  key={row.id || rowIdx}
                >
                  {row.cells.map((cell, cellIdx) => (
                    <td
                      key={cell.column.id || cellIdx}
                      {...cell.getCellProps()}
                    >
                      {cell.column.id === "salesPersonLeadId" ? (
                        <span>
                          {getSalesLeadName(row.original.salesPersonLeadId)}
                        </span>
                      ) : (
                        cell.render("Cell")
                      )}
                    </td>
                  ))}
                  <td key={`action-${row.id || rowIdx}`}>
                    <TableActionBtnGroup
                      buttonUrl={(event) =>
                        toggleSalesEdit(row.original.id, event)
                      }
                      onDelete={() => handleDeleteSelected(row.original.id)}
                      tooltips={EDIT_REFERRAL_TOOLTIP_CONFIG}
                    />
                  </td>
                </tr>
              </React.Fragment>
            );
          })
        )}
      </tbody>
    </table>
  );
};

ReferralSalesLeadTable.propTypes = {
  columns: PropTypes.array.isRequired,
  getTableProps: PropTypes.func.isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  headerGroups: PropTypes.array.isRequired,
  prepareRow: PropTypes.func.isRequired,
  rows: PropTypes.array.isRequired,
  getSalesLeadName: PropTypes.func.isRequired,
  toggleSalesEdit: PropTypes.func.isRequired,
  handleDeleteSelected: PropTypes.func.isRequired,
  EDIT_REFERRAL_TOOLTIP_CONFIG: PropTypes.object
};

export default ReferralSalesLeadTable;
